import {AxiosResponse} from 'axios';
import BaseApi from './BaseApi';
import {Headers} from '../';
import {LLMFeature} from "../../Models/ApiBackendEnums";

type LLMFeatureActivationDTO = API_BACKEND.Schemas.LLMFeatureActivationDTO;

export default class BackendApi extends BaseApi {
    constructor(baseUrl: string, token: string, headers: Headers) {
        super(`${baseUrl}/api/dydubox-backend`, token, headers);
    }

    getFeatureActivationByName = (feature: LLMFeature): Promise<AxiosResponse<LLMFeatureActivationDTO>> =>
        this.secureAxiosClient.get<LLMFeatureActivationDTO>(`/llm/features/activations/${feature}`);
}